@use '@/styles/tokens' as *;

// Figma close button (node 131:1841): 24px round dismiss control.

.closeButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 4px;
  border: none;
  border-radius: 12px;
  background: $color-neutral-200;
  color: var(--text-primary);
  cursor: pointer;

  > svg {
    width: 14px;
    height: 14px;
  }

  &:hover:not(:disabled) {
    background: $color-control-hover;
  }

  &:focus-visible {
    outline: none;
    box-shadow: var(--focus-ring);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

// Figma 1158:611330 — the same 24/4/12 disc over imagery. Declared after `.closeButton` on
// purpose: both are single-class selectors, so source order is what lets it win.
.dark {
  background: $color-neutral-950; // Figma Neutral/950 #111111 — exact
  color: var(--text-inverse); // Figma Text/Inverse #FFFFFF — exact

  &:hover:not(:disabled) {
    // Not drawn. One step up the same ramp, mirroring the default tone's own hover lift.
    background: $color-neutral-900;
  }
}
